import React from 'react';

import { Show, TextField, SimpleShowLayout, ArrayField, Datagrid, BooleanField } from 'react-admin';

import { ActionsWithBackButton } from '../../../components/actionbars/ActionsWithBackButton';
import ChipArrayField from 'components/fields/ChipArrayField';
import { MaskedTokenFieldOnce } from 'components/fields/TokenField';
import { AppReferenceManyField } from 'components/list/AppReferenceManyField';
import { ScrollingWrapperInCard } from 'components/ScrollingWrapper';
import { AppSecretsBlock } from 'resources/app-secrets';
import { SelectEnumField } from 'components/fields/SelectEnumField';
import { ThirdPartyAppStatus } from 'entities/ThirdPartyAppStatus';


export const ThirdPartyAppsShow = ({permissions, ...props}) => (
	<Show actions={<ActionsWithBackButton />} {...props}>
		<SimpleShowLayout>
			<TextField source="id" />
			<TextField source="client_name" />
			<SelectEnumField source="status" enumObj={ThirdPartyAppStatus} enumName="third_party_app.status" />
			<TextField source="client_id" />
			<MaskedTokenFieldOnce
				source="client_secret"
				viewedField="client_secret_viewed"
				revealNotice="resources.third-party-apps.reveal_notice"
				addLabel
			/>
			<TextField source='redirect_uri' />
			<TextField source='disconnect_url' />
			<TextField source='connect_url' />
			<TextField source="token_endpoint_auth_method" />
			<ChipArrayField source="scope" />
			<ChipArrayField source="grant_types" />
			<ChipArrayField source="response_types" />
			<ScrollingWrapperInCard>
				<AppReferenceManyField label="resources.app-secrets.name" reference="app-secrets" target="oauth2_client_id">
					<AppSecretsBlock />
				</AppReferenceManyField>
			</ScrollingWrapperInCard>
			<BooleanField source="form_schema_enabled" label="resources.third-party-apps.form_schema.enabled" />
			<ArrayField source="form_schema" label="resources.third-party-apps.form_schema.title">
				<Datagrid>
					<TextField source="name" label="resources.third-party-apps.form_schema.fields.name" />
					<TextField source="type" label="resources.third-party-apps.form_schema.fields.type" />
					<TextField source="label" label="resources.third-party-apps.form_schema.fields.label" />
					<BooleanField source="required" label="resources.third-party-apps.form_schema.fields.required" />
				</Datagrid>
			</ArrayField>
		</SimpleShowLayout>
	</Show>
);
